import type { CommonResultError } from "../types/api";
import type { ElementContent } from "mu-vue-utils/Utils/types";

/** Minimal HTML-entity escape for text interpolated into a flash message's `{ html }` payload. */
function escapeHtml(text: string): string {
  return text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
}

/**
 * TL vrstva (murdej/ts-link-php) posílá chybu z výjimky jako celý `(string) $exception`
 * (`ClassName: zpráva in /cesta/k/souboru.php:123\nStack trace:\n#0 ...`). Pro zobrazení
 * uživateli chceme jen samotnou zprávu, ne cestu k souboru a stack trace.
 */
export function formatTlError(e: unknown): string {
  const raw = e instanceof Error ? e.message : String(e);
  const firstPart = raw.split('\nStack trace:')[0];
  const withoutClassPrefix = firstPart.replace(/^[\w\\]+:\s*/, '');
  const withoutLocation = withoutClassPrefix.replace(/\s+in\s+\S+:\d+$/, '');
  return withoutLocation || raw;
}

/**
 * Sibling of formatTlError() for the CommonResult convention (Murdej\DTO\CommonResult) — renders
 * field-level validation messages as an HTML list for a flash message (mu-vue-utils's `addFlash()`
 * renders an `ElementContent` of shape `{ html }` via `v-html`, same as a plain string). Existing
 * call sites (`addFlash(formatCommonResultErrors(result.errors), 'danger')`) don't need to change —
 * `ElementContent` already covers both a plain string and `{ html }`.
 */
export function formatCommonResultErrors(errors: CommonResultError[]): ElementContent {
  if (errors.length === 0) return '';
  if (errors.length === 1) return errors[0].message;
  return { html: '<ul class="mb-0 ps-3">' + errors.map(e => `<li>${escapeHtml(e.message)}</li>`).join('') + '</ul>' };
}
